import tailwindUtils from "./helpers/tailwind-utils";
import ariaHelper from "./helpers/aria-helper";

export default {
    currentOpenSubMenu: null,

    resetMenu(header, backButton) {
        if (header.classList.contains("open-tab")) {
            header.classList.remove("open-tab");
            backButton.classList.add("hidden");
            backButton.classList.remove("flex");
        }
        this.currentOpenSubMenu = null;
    },

    init() {
        const header = document.getElementById("header");
        const headerMenu = document.getElementById("header-menu-tabs");
        let backButton = document.querySelector(".back-button");
        const lg = tailwindUtils.getMQValue("lg");

        if (headerMenu) {
            let tabs = headerMenu.querySelectorAll(".tab");

            window.addEventListener("resize", () => {
                // reset menu on resize
                this.resetMenu(header, backButton);
            });

            if (tabs.length > 0) {
                tabs.forEach(el => {
                    el.addEventListener("click", function () {
                        const button = el.querySelector("[aria-controls='services-submenu']");
                        ariaHelper.setAriaExpanded(button);
                        toggleClass(this, "active");
                        if (!header.classList.contains("open-tab")) {
                            header.classList.add("open-tab");
                            backButton.classList.remove("hidden");
                            backButton.classList.add("flex");
                        }
                        this.currentOpenSubMenu = this;
                    })
                })
            }

            if (backButton) {

                backButton.addEventListener("click", function () {

                    let tabContentActive = document.querySelector(".open-tab .tab-content.active-tab-content");
                    // const timelineBackBtn = anime.timeline({ duration: 400, easing: "easeOutQuint" });
                    let tabButtons = document.querySelectorAll(".tab-button");

                    if (tabContentActive && window.matchMedia("(max-width:" + lg + "px)").matches) {

                        tabButtons.forEach((tabButton) => {
                            tabButton.classList.remove("remove-button");
                        })
                        tabContentActive.classList.remove("active-tab-content");
                        // timelineBackBtn
                        // 	.add({
                        // 		targets: ".tab-content.active-tab-content",
                        // 		translateX: "100%",
                        // 		complete: () => {
                        // 			tabButtons.forEach((tabButton) => {
                        // 				tabButton.classList.remove("remove-button");
                        // 			})
                        // 			tabContentActive.classList.remove("active-tab-content");
                        // 		},
                        // 	}, 200);
                    }

                    if (header.classList.contains("open-tab")) {
                        header.classList.remove("open-tab");
                        backButton.classList.add("hidden");
                        backButton.classList.remove("flex");
                    }

                    tabs.forEach(el => {
                        if (el.classList.contains("active")) {
                            el.classList.remove("active")
                        }
                    })
                })
            }
        }

        // Run on load
        const element = document.querySelector(".back-button");

        ariaHelper.setAriaHiddenOnDesktop(element);

        window.addEventListener("resize", () => ariaHelper.setAriaHiddenOnDesktop(element));

        function toggleClass(elem, cls) {
            elem.classList.toggle(cls);

            siblings(elem).forEach(node => {
                node.classList.remove(cls)
            })

            if (elem.classList.contains("active") && window.matchMedia("(max-width:" + lg + "px)").matches) {

                // const timeline = anime.timeline({ duration: 400, easing: "easeOutQuint" });
                let tabContent = elem.querySelector(".tab-content");
                let tabButtons = document.querySelectorAll(".tab-button");

                if (!tabContent.classList.contains("active-tab-content")) {
                    const headerMenuContainer = document.getElementById("header-menu-lang-container");
                    headerMenuContainer.scrollTo(0, 0);
                    tabContent.classList.add("active-tab-content");
                    tabButtons.forEach((tabButton) => {
                        tabButton.classList.add("remove-button");
                    })
                    // timeline
                    // 	.add({
                    // 		targets: ".active .tab-content",
                    // 		translateX: "0%",
                    // 		complete: () => {
                    // 			tabContent.classList.add("active-tab-content");
                    // 			tabButtons.forEach((tabButton) => {
                    // 				tabButton.classList.add("remove-button");
                    // 			})
                    // 		},
                    // 	}, 200);
                }
            }
        }

        function siblings(elem) {
            const nodes = [...elem.parentNode.children]
            return nodes.filter(node => node !== elem)
        }


    },
}